const Result = () => {
  return <>This is Result Page</>
}

export default Result
